<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Headers/H6'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=10181-38168&m=dev'
*/

defineOptions({
  name: 'HeadingH6',
})
</script>

<template>
  <h5 class="heading-h6">
    <slot />
  </h5>
</template>

<style scoped lang="scss" src="./HeadingH6.scss" />
